/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VaultWebhookPayload } from '../models/VaultWebhookPayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class VaultWebhookService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public post(
        requestBody?: VaultWebhookPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vault/webhook',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
